import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';

import VerifiedUserTwoToneIcon from '@mui/icons-material/VerifiedUserTwoTone';

import { Button, TablePagination } from '@mui/material';

import {
  Quorum_SEG_LIST,
  NONE_OF_THE_EMPLOYERS,
  ELIGIBLE,
} from '../../constants/SelectEmployerProgram';

import './SelectEmployerProgram.css';

export const SelectEmployerProgram = ({ onConfirmEligible, originalSegsList = {}, filter }) => {
  const [segsList, setSegsList] = useState(originalSegsList);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [employersPerRow, setEmployersByRow] = useState({ [page]: Quorum_SEG_LIST });

  useEffect(() => {
    const employerNames = [...Quorum_SEG_LIST];

    const currentEmployerRow = {};
    let count = 0;

    while (employerNames.length) {
      const rowOfEmployers = employerNames.splice(0, rowsPerPage);

      currentEmployerRow[count] = [...rowOfEmployers];
      count++;
    }
    setEmployersByRow(currentEmployerRow);
  }, [rowsPerPage]);

  const handleSegsClick = (seg) => {
    if (segsList[seg]) {
      const copySEGsList = { ...segsList };
      delete copySEGsList[seg];
      setSegsList(copySEGsList);
    } else {
      setSegsList({ ...segsList, [seg]: seg });
    }
  };

  return (
    <div>
      <div className="employers-list-container">
        {employersPerRow[page].map((seg) => {
          return (
            <Button
              sx={{
                width: '100%',
                color: 'black',
                textAlign: 'left',
                textTransform: 'initial',
                backgroundColor: segsList[seg] ? 'lightgreen' : 'white',
                display: 'flex',
                justifyContent: 'space-between',
                borderRadius: '15px',
                border: '1px solid black',
                lineHeight: '2',
                padding: '15px',
                marginBottom: '10px',
              }}
              onClick={() => handleSegsClick(seg)}
            >
              <div>{seg}</div>{' '}
              <div>
                {' '}
                <VerifiedUserTwoToneIcon sx={{ color: 'green' }} />{' '}
              </div>
            </Button>
          );
        })}
      </div>
      <TablePagination
        component="div"
        count={Quorum_SEG_LIST.length}
        page={page}
        onPageChange={(_, page) => {
          setPage(page);
          mixpanel.track(`Open Select Employer Group ${filter}`, {
            SEG: segsList,
            action: 'Change Page',
            page,
          });
        }}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
          mixpanel.track(`Open Select Employer Group ${filter}`, {
            SEG: segsList,
            action: 'Rows Per Page Change',
          });
        }}
        rowsPerPageOptions={[8, 25, 50, 100]}
      />
      <div className="select-employer-program-buttons-wrapper">
        <Button
          onClick={() => onConfirmEligible(false, segsList)}
          disabled={Object.keys(segsList).length}
          variant="contained"
          color="error"
          sx={{
            marginRight: '5px',
            padding: '12px 8px',
            borderRadius: 2,
            textTransform: 'initial',
          }}
        >
          {NONE_OF_THE_EMPLOYERS}
        </Button>

        <Button
          onClick={() => {
            onConfirmEligible(true, segsList);
          }}
          variant="contained"
          color="success"
          sx={{ marginLeft: '5px', padding: '8px', borderRadius: 2, textTransform: 'initial' }}
        >
          {ELIGIBLE}
        </Button>
      </div>
    </div>
  );
};
